<div mat-dialog-title class="dialog-header">
  <button type="button" class="close-button" (click)="onCancel()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h4>Enter Values for "{{ data.fieldLabel }}"</h4>
</div>

<mat-dialog-content>
  <p class="hint">Enter values separated by <strong>~</strong> (e.g. <em>Value1 ~ Value2 ~ Value3</em>)</p>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Values</mat-label>
    <textarea matInput [(ngModel)]="rawText" rows="5" placeholder="Value1 ~ Value2 ~ Value3"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" type="button">Cancel</button>
  <button mat-raised-button color="primary" (click)="onOk()" type="button">OK</button>
</mat-dialog-actions>
